import React from "react";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const handlePageChange = (page) => {
    onPageChange(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex justify-center items-center space-x-4 py-12 bg-black border-b">
      <button
        onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="px-4 py-2 text-sm tracking-[0.1em] uppercase text-gray-400 hover:text-white disabled:opacity-50 transition-colors"
      >
        Previous
      </button>
      <div className="flex space-x-2">
        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i + 1}
            onClick={() => handlePageChange(i + 1)}
            className={`w-8 h-8 text-sm ${
              currentPage === i + 1
                ? 'bg-white text-black'
                : 'text-gray-400 hover:text-white'
            } transition-colors`}
          >
            {i + 1}
          </button>
        ))}
      </div>
      <button
        onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className="px-4 py-2 text-sm tracking-[0.1em] uppercase text-gray-400 hover:text-white disabled:opacity-50 transition-colors"
      >
        Next
      </button>
    </div>
  );
}
